import React from 'react';
import 'dayjs/locale/es';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

interface DateRangePickerProps {
    startDate: any;
    endDate: any;
    onChange: (startDate: any, endDate: any) => void;
    adapterLocale?: string;
}

const DateRangePickerComponent: React.FC<DateRangePickerProps> = ({
    startDate,
    endDate,
    onChange,
    adapterLocale = 'es'
}) => {
    const today = dayjs();

    const parsedStartDate = startDate && dayjs(startDate).isValid() ? dayjs(startDate) : null;
    const parsedEndDate = endDate && dayjs(endDate).isValid() ? dayjs(endDate) : null;

    const handleStartDateChange = (date: Dayjs | null) => {
        const validDate = date && dayjs(date).isValid() ? date : null;
        onChange(validDate, endDate);
    };

    const handleEndDateChange = (date: Dayjs | null) => {
        const validDate = date && dayjs(date).isValid() ? date : null;
        onChange(startDate, validDate);
    };
    const clearStartDate = () => {
        onChange(null, endDate);
    };

    const clearEndDate = () => {
        onChange(startDate, null);
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ position: 'relative', marginRight: 16 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
                    <DatePicker
                        slotProps={{
                            textField: {
                                inputProps: { 'data-testid': 'range-startDate' }
                            }
                        }}
                        label="Fecha de Inicio"
                        value={parsedStartDate}
                        onChange={handleStartDateChange}
                        disableFuture={true}
                        maxDate={endDate || today}
                        format="DD/MM/YYYY"
                    />
                    {startDate && (
                        <IconButton
                            onClick={clearStartDate}
                            style={{ position: 'absolute', top: 16, right: 40 }}
                            size="small"
                        >
                            <ClearIcon />
                        </IconButton>
                    )}
                </LocalizationProvider>
            </div>
            <div style={{ position: 'relative' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
                    <DatePicker
                        slotProps={{
                            textField: {
                                inputProps: { 'data-testid': 'range-endDate' }
                            }
                        }}
                        label="Fecha de Fin"
                        value={parsedEndDate}
                        onChange={handleEndDateChange}
                        disableFuture={true}
                        minDate={startDate || null}
                        maxDate={today}
                        format="DD/MM/YYYY"
                    />
                    {endDate && (
                        <IconButton
                            onClick={clearEndDate}
                            style={{ position: 'absolute', top: 16, right: 40 }}
                            size="small"
                        >
                            <ClearIcon />
                        </IconButton>
                    )}
                </LocalizationProvider>
            </div>
        </div>
    );
};

export default DateRangePickerComponent;
